// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2LlSh","head":"ProcedureTableInfo_head__3uHJj"};